export enum LoyaltySearchType {
    EARN = 'EARN',
    BURN = 'BURN',
    UNKNOWN = '',
}
